import { render, staticRenderFns } from "./CTranslateModal.vue?vue&type=template&id=aa1c719c&scoped=true&"
import script from "./CTranslateModal.vue?vue&type=script&lang=js&"
export * from "./CTranslateModal.vue?vue&type=script&lang=js&"
import style0 from "./CTranslateModal.vue?vue&type=style&index=0&id=aa1c719c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1c719c",
  null
  
)

export default component.exports